module.exports = __webpack_public_path__ + "static/media/green-tick.7ea29756.svg";